module.exports = __webpack_public_path__ + "img/62a1503.webp";